export const groupCollectionByKey = (
  key: string,
  collection: Array<any>
): Array<any> => {
  return collection.reduce((objectsByKeyValue, obj) => {
    const { attributes } = obj;
    const value = attributes[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
      attributes
    );
    return objectsByKeyValue;
  }, {});
};

export const getKeyByValue = (object: any, value: string): any => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const isNullOrUndefined = <T>(
  obj: T | null | undefined
): obj is null | undefined => {
  return typeof obj === "undefined" || obj === null;
};
